import { getProviderFromId } from '@stacks/connect-ui';

import { PROVIDERS } from '../hooks/useData';

const PROVIDER_ID_BY_NAME: Record<string, string> = {
  Leather: 'LeatherProvider',
  Xverse: 'XverseProviders.BitcoinProvider',
};

export const isWalletInstalled = (name: string): boolean => {
  const id = PROVIDER_ID_BY_NAME[name];
  if (!id) return false;

  return !!getProviderFromId(id);
};

export const resolveProvider = (provider: PROVIDERS) => {
  if (provider === PROVIDERS.Ledger) return null;

  const id = PROVIDER_ID_BY_NAME[provider];
  if (id) return getProviderFromId(id) || null;

  return null;
};
